import {
  Button,
  Tooltip,
  ButtonProps,
  TooltipProps,
  IconButton,
  IconButtonProps,
} from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import React from 'react';

interface TooltipButtonProps extends Omit<
  ButtonProps & IconButtonProps,
  'title' | 'children'
> {
  title: string;
  buttonTitle?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  Icon?: SvgIconComponent; // Make Icon optional
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>;
}

export const TooltipButton = ({
  title,
  buttonTitle,
  onClick,
  Icon,
  tooltipProps,
  // Rest of the ButtonProps
  ...buttonProps
}: TooltipButtonProps) => (
  <Tooltip
    title={title}
    slotProps={{
      popper: {
        sx: {
          zIndex: 4000,
        },
      },
    }}
    {...tooltipProps}
  >
    <span>
      {Icon ? (
        <IconButton
          aria-label={buttonTitle || title}
          onClick={onClick}
          {...buttonProps}
        >
          <Icon />
        </IconButton>
      ) : (
        <Button
          value={buttonTitle || title}
          aria-label={buttonTitle || title}
          onClick={onClick}
          {...buttonProps}
        >
          {buttonTitle || title}
        </Button>
      )}
    </span>
  </Tooltip>
);
